/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import { useRecoilState } from 'recoil';
import Select, { CssTextField } from 'components/select';
import InfoImg from 'pages/provisioning/_components/InfoImg';
import { toggleCreateLandingZone, landingZoneForm } from 'pages/app-profiles/store';

const StorageSubResource = ({ index }) => {
    const [lzModal] = useRecoilState(toggleCreateLandingZone);
    const [landZoneForm, setLandingZoneForm] = useRecoilState(landingZoneForm);
    const [options, setOptions] = React.useState([]);

    const setStorageSubResource = (storageSubResource) => {
        const form = { ...landZoneForm };
        try {
            const result = form.privateEndPoints.map((item, i) => {
                let obj = { ...item };
                if (index === i) {
                    obj = { ...obj, storageSubResource: storageSubResource !== '' || storageSubResource !== null ? storageSubResource : null };
                }
                return obj;
            });
            form.privateEndPoints = result;
        } catch (e) {
            // eslint-disable-next-line
            console.log(e);
        }
        setLandingZoneForm(form);
    };

    const seldValueExistsInOptions = (value) => options.find((option) => value === option?.label);

    const handleOnSelectChange = (selected) => {
        if (seldValueExistsInOptions(selected?.label)) {
            setStorageSubResource(selected?.label);
        } else {
            setStorageSubResource(null);
        }
    };

    React.useEffect(() => {
        if (options?.length && options?.length > 0 && lzModal?.lzDetails) {
            const storageSubResource = options.find((value) => lzModal?.lzDetails?.config?.privateEndPoints[index]?.storageSubResource === value?.label);
            if (storageSubResource) setStorageSubResource(storageSubResource?.label);
        }
        if (options?.length && options?.length === 1) {
            handleOnSelectChange(options[0]);
        }
    }, [options]);

    React.useEffect(() => {
        setOptions([
            { label: 'Blob', value: 'Blob' },
            { label: 'Blob_Secondary', value: 'Blob_Secondary' },
            { label: 'File', value: 'File' },
            { label: 'Table', value: 'Table' },
        ]);
    }, []);

    return (
        <>
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                <Select
                    key="StorageSubResource"
                    value={landZoneForm?.privateEndPoints?.[index]?.storageSubResource}
                    options={options}
                    handleOnSelect={(value) => handleOnSelectChange(value)}
                    disableClearable={false}
                    renderInput={(params) => (
                        <CssTextField
                            {...params}
                            label="Storage Sub-Resource"
                            placeholder="Storage Sub-Resource"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: <>{params.InputProps.endAdornment}</>,
                            }}
                        />
                    )}
                />
                <InfoImg title="Type  Endpoint Name" />
            </Stack>
        </>
    );
};
StorageSubResource.propTypes = {
    index: PropTypes.number,
};

StorageSubResource.defaultProps = {
    index: 0,
};

export default React.memo(StorageSubResource);
